import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OperationsService } from 'src/app/core/services/operations.service';

@Injectable()
export class UserService {

    public utenteFull = new Subject<any>();

    constructor(private helpers: HelpersService, private operationService: OperationsService){}

    initializeUser() {
        this.helpers.getLoggedUserData().subscribe(response=>{
            this.operationService.getUtenteProfilo(response.username).subscribe(response=>{
              this.setUtente(response.utente);
            });
        });
    }

    setUtente(utenteFull) {
        this.utenteFull.next(utenteFull);
    }

    getUtente() : Observable<any> {
        return this.utenteFull.asObservable();
    }

}
